import React from 'react'
import { Formik, FormikHelpers } from 'formik'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import * as yup from 'yup'

import tw from 'tailwind-rn'
import styles from './styles'
import { HGTextInput } from '../../components/Form'
import { HGButton, HGText, HGLink } from '../../components/HGUI'

const validationSchema = yup.object({
  username: yup
    .string()
    .email('Bitte gib eine gültige E-Mail-Adresse an.')
    .required('Bitte gib eine gültige E-Mail-Adresse an.'),
  password: yup
    .string()
    .min(6, 'Bitte geben Sie ein Passwort mit mindestens 6 Zeichen ein')
    .required('Bitte geben Sie ein sichereres Passwort ein.'),
  passwordConfirm: yup
    .string()
    .oneOf([yup.ref('password'), null], 'Passwörter müssen übereinstimmen.'),
})

export type SignUpSecondStepValues = {
  username: string
  password: string
  passwordConfirm: string
}

const initialValues: SignUpSecondStepValues = {
  username: '',
  password: '',
  passwordConfirm: '',
}

type Props = {
  onSubmit: (
    values: SignUpSecondStepValues,
    setSubmitting: (value: boolean) => void,
    setStatus: (status: any) => void
  ) => void
}

const SignUpForm = (props: Props) => {
  const { onSubmit } = props
  const { navigate } = useNavigation()

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(
        values: SignUpSecondStepValues,
        { setSubmitting, setStatus }: FormikHelpers<SignUpSecondStepValues>
      ) => {
        // console.log(values)
        onSubmit(values, setSubmitting, setStatus)
      }}
    >
      {({
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        isValid,
        values,
        errors,
        status,
      }) => (
        <View>
          <View>
            <HGTextInput
              onChangeText={handleChange('username')}
              onBlur={handleBlur('username')}
              value={values.username}
              autoCapitalize="none"
              placeholder="E-Mail-Adresse …"
              textContentType="emailAddress"
              // autoCorrect={false}
              keyboardType="email-address"
            />

            {errors.username && (
              <HGText style={tw('text-sm mt-1 text-red-500')}>
                {errors.username}
              </HGText>
            )}
          </View>

          <View style={tw('mt-4')}>
            <HGTextInput
              onChangeText={handleChange('password')}
              onBlur={handleBlur('password')}
              value={values.password}
              autoCapitalize="none"
              placeholder="Passwort …"
              textContentType="newPassword"
              secureTextEntry
            />

            <HGText style={tw('text-sm mt-1 text-gray-600')}>
              Das Passwort muss mindestens 6 Zeichen lang sein.
            </HGText>

            {errors.password && (
              <HGText style={tw('text-sm mt-1 text-red-500')}>
                {errors.password}
              </HGText>
            )}
          </View>

          <View style={tw('mt-4')}>
            <HGTextInput
              onChangeText={handleChange('passwordConfirm')}
              onBlur={handleBlur('passwordConfirm')}
              value={values.passwordConfirm}
              autoCapitalize="none"
              placeholder="Passwort wiederholen …"
              secureTextEntry
              onSubmitEditing={() => handleSubmit}
            />

            {errors.passwordConfirm && (
              <HGText style={tw('text-sm mt-1 text-red-500')}>
                {errors.passwordConfirm}
              </HGText>
            )}
          </View>

          <View style={tw('mt-6')}>
            {status && (
              <HGText style={tw('text-sm mb-2 text-red-500')}>{status}</HGText>
            )}

            <HGButton
              disabled={isSubmitting || !isValid}
              title={!isSubmitting ? 'Weiter' : 'Bitte warten …'}
              onPress={handleSubmit}
            />

            {status && (
              <View style={tw('items-center mt-6')}>
                <HGLink onPress={() => navigate('SignIn')}>
                  Zurück zur Startseite
                </HGLink>
              </View>
            )}
          </View>
        </View>
      )}
    </Formik>
  )
}

export default SignUpForm
